webpackJsonp([246384609461072],{

/***/ 533:
/***/ (function(module, exports) {

	module.exports = [{"key":"yahoo-global","company":"Yahoo! Sports Latin America","description":"Global Sports implementation for Latin America Sports.","url":"https://br.esportes.yahoo.com/"},{"key":"yahoo-sports","company":"Yahoo! Sports","description":"Plethora of features built for the #1 sports site in North America.","url":"https://sports.yahoo.com/"},{"key":"nique","company":"Technique","description":"Georgia Tech newspaper redesign with a custom Wordpress install.","url":"http://www.nique.net/"},{"key":"world-cup","company":"Yahoo! Sports World Cup","description":"Global site for the 2010 World Cup with support for 22 countries.","url":"https://g.sports.yahoo.com/soccer/world-cup/"},{"key":"gts","company":"GTS Inc","description":" Redesign of a website for an Atlanta based Tech Consulting company.","url":"https://www.akshayp.com/GTS/"},{"key":"medivity","company":"Medivity LLC","description":"Site for an upcoming bio-medical startup in Atlanta.","url":"http://www.medivity.com/"},{"key":"mlb-scenario","company":"Yahoo! Sports","description":"MLB Scenario Generator for Yahoo! Sports as part of an intern project.","url":"https://sports.yahoo.com/mlb/playoffscenario"},{"key":"fall","company":"Fall Detection","description":"Interactive media site for a new device being launched to detect falls.","url":"http://www.ece.gatech.edu/academic/courses/ece4007/09spring/ece4007l05/ak9/"},{"key":"queue","company":"Queue Cafe","description":"Logo and site with mostly a menu designed for a Cafe in New Zealand.","url":"http://www.queuecafe.com/"},{"key":"survive","company":"Survive in the Wild","description":"Designed A Survival Guide for a Literature class at Georgia Tech.","url":"https://www.akshayp.com/wp-content/uploads/survival/"},{"key":"parrot","company":"First Site","description":"My first Website. Only here for nostalgic reasons.","url":"https://www.akshayp.com/wp-content/uploads/Parrot/"}]

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _portfolio = __webpack_require__(533);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portfolio = function (_React$Component) {
	    _inherits(Portfolio, _React$Component);
	
	    function Portfolio() {
	        _classCallCheck(this, Portfolio);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Portfolio.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'portfolio post' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Portfolio' }),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _portfolio2.default.map(function (site) {
	                    return _react2.default.createElement(
	                        'li',
	                        { className: 'grid-33', key: site.url },
	                        _react2.default.createElement(
	                            'a',
	                            { href: site.url, target: 'noopener' },
	                            _react2.default.createElement('img', { src: '/img/' + site.key + '.jpg', alt: site.company }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                site.description
	                            )
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return Portfolio;
	}(_react2.default.Component);
	
	exports.default = Portfolio;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-8ba9fc2a675bbe8ce0e7.js